import { ajaxSend } from '../../../api/api';
import { getLocalSettings, updateSettings } from '../../settings/api/personal';
export const base = '/v1/conversations';
const OUTBOUND_ADDRESS_LOCALSTORAGE_NAME = 'contactFormOutboundAddress';
export function getOwnConversations(payload) {
    const { userId } = payload;
    return ajaxSend({
        path: `${base}?status=open&agent=${userId}`,
    });
}
export function pauseCallRecording(payload) {
    const { csid } = payload;
    return ajaxSend({
        method: 'PUT',
        path: `${base}/${csid}/recordings/pause`,
    });
}
export function resumeCallRecording(payload) {
    const { csid } = payload;
    return ajaxSend({
        method: 'PUT',
        path: `${base}/${csid}/recordings/resume`,
    });
}
export function extendAcw(payload) {
    const { csid, duration } = payload;
    return ajaxSend({
        method: 'PUT',
        path: `${base}/${csid}/acw`,
        data: {
            duration_in_seconds: duration,
        },
    });
}
export function completeAcw(payload) {
    const { csid } = payload;
    return ajaxSend({
        method: 'DELETE',
        path: `${base}/${csid}/acw`,
    });
}
export function addWrapup(payload) {
    const { csid, note, agentId } = payload;
    return ajaxSend({
        path: `${base}/${csid}/wrapup`,
        method: 'POST',
        data: {
            author_id: agentId,
            message: note,
        },
    });
}
export function getConversation(payload) {
    const { csid } = payload;
    return ajaxSend({
        path: `/v2/conversations/${csid}`,
    });
}
export function submitMessage(payload) {
    const { csid, message: text, content_type, channel, requestID, from, to_emails, cc_list_v2, bcc_list_v2, attachments_v2, } = payload;
    const request = {
        method: 'POST',
        path: `${base}/${csid}/messages`,
        data: {
            attributes: {
                text,
            },
            channel: channel,
        },
    };
    if (requestID && typeof requestID === 'string') {
        request.data.attributes.frontend_id = requestID;
    }
    // From email.
    if (from && typeof from === 'string') {
        request.data.attributes.from = from;
    }
    if (content_type &&
        typeof content_type === 'string' &&
        content_type === 'html') {
        request.data.attributes.content_type = 'Html';
    }
    if (to_emails && Array.isArray(to_emails) === true) {
        request.data.to_emails = to_emails;
    }
    if (cc_list_v2 && Array.isArray(cc_list_v2) === true) {
        request.data.cc_emails = cc_list_v2;
    }
    if (bcc_list_v2 && Array.isArray(bcc_list_v2) === true) {
        request.data.bcc_emails = bcc_list_v2;
    }
    if (attachments_v2 && Array.isArray(attachments_v2) === true) {
        request.data.attributes.attachedfiles_v2 = JSON.stringify(attachments_v2);
    }
    return ajaxSend(request)
        .then((data) => {
        data.responseID = requestID;
        return data;
    })
        .catch((exception) => {
        exception.responseID = requestID;
    });
}
export function conversationClose(payload) {
    const { csid } = payload;
    return ajaxSend({
        method: 'PUT',
        path: `${base}/${csid}/close`,
    });
}
export function conversationSetToPending(payload) {
    const { csid, timestamp, queueId } = payload;
    const data = {
        timestamp,
    };
    if (queueId) {
        data.queue_id = queueId;
    }
    return ajaxSend({
        method: 'PUT',
        path: `${base}/${csid}/pending`,
        data: data,
    });
}
export function conversationCancelPending(payload) {
    const { csid } = payload;
    return ajaxSend({
        method: 'PUT',
        path: `${base}/${csid}/cancel_pending`,
    });
}
export function responseToOffer(payload) {
    const { csid, did_accept } = payload;
    return ajaxSend({
        path: `${base}/${csid}/respond`,
        method: `PUT`,
        data: {
            did_accept: did_accept,
        },
    });
}
export function responseToTransferOffer(payload) {
    const { csid, did_accept } = payload;
    return ajaxSend({
        path: `${base}/${csid}/transfer/answer`,
        method: `PUT`,
        data: {
            accepted: did_accept,
        },
    });
}
export function claimConversation(payload) {
    const { csid } = payload;
    return ajaxSend({
        path: `${base}/${csid}/claim`,
        method: `PUT`,
    });
}
export function tagConversation(payload) {
    const { csid, tag } = payload;
    return ajaxSend({
        path: `${base}/${csid}/tags`,
        method: `POST`,
        data: {
            name: tag,
        },
    });
}
export function untagConversation(payload) {
    const { csid, tag } = payload;
    return ajaxSend({
        path: `${base}/${csid}/tags/${tag}`,
        method: `DELETE`,
    });
}
export function setConversationOutboundAddress(payload = null) {
    if (!payload) {
        console.error('outboundAddress - No valid payload given.');
        return Promise.reject(null);
    }
    const { outboundAddress } = payload;
    if (typeof outboundAddress !== 'string') {
        console.error('outboundAddress - No valid payload given.');
        return Promise.reject(null);
    }
    try {
        updateSettings({
            key: OUTBOUND_ADDRESS_LOCALSTORAGE_NAME,
            value: outboundAddress,
        });
        return Promise.resolve(outboundAddress);
    }
    catch (e) {
        return Promise.reject(e);
    }
}
export function getConversationOutboundAddress() {
    try {
        const localSettings = getLocalSettings();
        if (localSettings) {
            return Promise.resolve(localSettings.contactFormOutboundAddress);
        }
        return Promise.resolve(null);
    }
    catch (e) {
        return Promise.reject(e);
    }
}
